export default "__VITE_ASSET__B7pSxmae__"